<template>
    <QuestionBaseQuiz :question="question">
        <div>
            <HintAlert v-if="question.options.starts_with" class="mt-1">
                <span class="font-semibold">{{ $t('messages.starts_with') }}:</span>
                {{ question.options.starts_with }}
            </HintAlert>

            <draggable
                tag="div"
                v-model="pieces"
                group="pieces"
                v-bind="dragOptions"
                @start="drag = true"
                @end="drag = false"
                handle=".handle"
                @change="reorderPieces()"
                :move="onMove"
                item-key="id"
                class="list-group flex flex-wrap"
            >
                <template #item="{ element: piece, index }">
                    <div
                        :class="{
                            'fixed-order cursor-not-allowed': piece.is_in_correct_position,
                            'list-group-item': !piece.is_in_correct_position,
                        }"
                        class="inline-block p-1 handle"
                    >
                        <BadgePill :key="index" :color="piece.is_in_correct_position ? 'green' : 'indigo'">
                            {{ piece.text }}
                        </BadgePill>
                    </div>
                </template>
            </draggable>

            <div class="pt-1 text-sm" :class="{ invisible: !answer }">
                <div>{{ $t('messages.your_answer') }}:</div>
                <div class="p-1 bg-gray-100">{{ answer }}&nbsp;</div>
            </div>

            <div>
                <button @click="answer = null" :class="{ invisible: !answer }" class="text-gray-600" type="button">
                    <svg
                        class="w-6 h-6 inline-block"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                    {{ $t('messages.delete_answer') }}
                </button>
            </div>
        </div>
    </QuestionBaseQuiz>
</template>

<script>
import BadgePill from '@/components/BadgePill.vue';
import draggable from 'vuedraggable';
import HintAlert from '@/components/Quiz/HintAlert.vue';
import QuestionBaseQuiz from '@/components/Quiz/QuestionBaseQuiz.vue';

export default {
    emits: ['update:modelValue'],
    name: 'QuestionOrderPhraseQuiz',

    components: {
        QuestionBaseQuiz,
        draggable,
        BadgePill,
        HintAlert,
    },

    props: {
        question: {
            required: true,
        },
        modelValue: {
            required: true,
        },
    },

    data() {
        return {
            answer: this.modelValue,
            pieces: this.question.options.pieces,
            drag: false,
        };
    },

    methods: {
        reorderPieces() {
            this.answer = this.pieces.map((p) => p.text).join(' ');
        },
        onMove({ dragged, draggedContext }) {
            if (dragged.className.indexOf('fixed-order') !== -1) {
                return false;
            }
            if (this.pieces[draggedContext.futureIndex].is_in_correct_position) {
                return false;
            }

            return true;
        },
    },

    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: 'pieces',
                disabled: false,
                ghostClass: 'ghost',
                filter: '.fixed-order',
            };
        },
    },

    watch: {
        answer(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
<style scoped>
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.2;
    background-color: #c7d2fe;
}
.list-group {
    min-height: 20px;
}
.list-group-item {
    cursor: move;
}
</style>
